// extracted by mini-css-extract-plugin
module.exports = {"button":"_1410bfd27b--button--RKZvy","icon":"_1410bfd27b--icon--M4N1r"};